enum Actions {
  /**
   * parameters: { hangupBy: string }
   */
  HangUp = "hangUp",

  MuteVideo = "muteVideo",
  UnmuteVideo = "unmuteVideo",

  MuteAudio = "muteAudio",
  UnmuteAudio = "unmuteAudio",

  HoldCall = "holdCall",
  ResumeCall = "resumeCall",

  ChangeSectionModule = "switchViewModule",

  // Text Channel
  SendTextChannelMessage = "sendTextChannelMessage",

  MuteRemoteVideo = "muteRemoteVideo",
  UnmuteRemoteVideo = "unmuteRemoteVideo",

  MuteRemoteAudio = "muteRemoteAudio",
  UnmuteRemoteAudio = "unmuteRemoteAudio",

  OpenChatPanel = "chatPanelOpen",
  SendSignalingMessage = "sendSignalingMessage",

  StartScreenShare = "startScreenShare",
  StopScreenShare = "stopScreenShare",
  SetMediaStream = "setMediaStream",
  ResetMediaStream = "resetMediaStream",

  PhotoPanelUpdate = "photoPanelUpdate",
}

enum Events {
  /**
   * parameters: { rtcId: string }
   */
  VideoCallCreated = "videoCallCreated",
  VideoCallEnded = "videoCallEnded",

  PeerAdded = "peerAdded",
  PeerRemoved = "peerRemoved",

  PeerVideoElementSet = "peerVideoElementSet",

  CallDataReceived = "callDataReceived",

  ConnectionStateChanged = "connectionStateChanged",

  AudioMuted = "audioMuted",
  AudioUnmuted = "audioUnmuted",

  VideoMuted = "videoMuted",
  VideoUnmuted = "videoUnmuted",

  CallHeld = "callHeld",
  CallResumed = "callResumed",

  SectionModuleChanged = "viewModuleSwitched",

  ModuleInitialized = "moduleInitialized",

  RoomJoined = "roomJoined",
  SignalingRegistered = "signalingRegistered",
  OnUserMedia = "onUserMedia",
  OnRemoteStream = "onRemoteStream",
  OnLocalStream = "onLocalStream",

  OnRTCOfferReceived = "onOffer",
  OnRTCAnswerReceived = "onAnswer",

  OnRTCAnswerSent = "onAnswerSent",
  OnRTCOfferSent = "onOfferSent",

  InteractionIdChanged = "interactionIdChanged",

  WebRTCConnected = "webRTCConnected",

  /**
   * parameters: { name: string, data: string(optional) }
   */
  CallEvent = "callEvent",

  RecordingStarted = "recordingStarted",
  RecordingFailed = "recordingFailed",
  RecordingRecovered = "recordingRecovered",
  RecordingTimestampOffset = "recordingTimestampOffset",

  // Text Channel
  TextChannelMessageReceived = "textChannelMessageReceived",
  TextChannelMessageSent = "textChannelMessageSent",

  // Text Chat
  SignalingMessageReceived = "signalingMessageReceived",
  SignalingMessageSent = "signalingMessageSent",

  // File Share
  FileShared = "fileShared",

  // Screen Share
  ScreenShareStarted = "screenShareStarted",
  ScreenShareFinished = "ScreenShareFinished",

  CameraChanged = "cameraChanged",

  PhotoTaken = "photoTaken",
  PhotoDeleted = "photoDeleted",
}

export { Actions, Events };
